<p
  class="resource-warnings-description"
  [innerHTML]="'resourcewarningsdescription' | translate: { pageName: source?.name }"
></p>

@if (warnings?.length > 0) {
  @if (defaultWarnings?.length > 0) {
    <app-default-warnings [warnings]="defaultWarnings"></app-default-warnings>
  }

  @if (resourceWarnings?.items?.length > 0) {
    <h4 class="resource-warnings-list-title">{{ 'resourcewarningspagesassets' | translate }}:</h4>

    <div class="resource-warnings-list-container">
      <app-grid
        class="no-header-h-padding"
        [data]="resourceWarnings.items"
        [colDefs]="colDefs"
        [rowStyles]="rowStyles"
        [colTemplates]="[actionColTemplate]"
      ></app-grid>
    </div>

    <ng-template #actionColTemplate let-data let-colDef="colDef" let-row="row">
      <div class="grid-actions" [ngStyle]="colDef.width != null && getColWidth(colDef)">
        <a
          class="action-btn edit-btn"
          [title]="'generaledit' | translate"
          [href]="row.link"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
      </div>
    </ng-template>
  }

  @if (collectionWarnings?.items?.length > 0) {
    <h4 class="resource-warnings-list-title">{{ 'resourcewarningscollections' | translate }}:</h4>

    <div class="resource-warnings-list-container">
      <app-grid
        class="no-header-h-padding"
        [data]="collectionWarnings.items"
        [colDefs]="collectionColDefs"
        [rowStyles]="rowStyles"
        [colTemplates]="[collectionActionColTemplate]"
      ></app-grid>
    </div>

    <ng-template #collectionActionColTemplate let-data let-colDef="colDef" let-row="row">
      <div class="grid-actions" [ngStyle]="colDef.width != null && getColWidth(colDef)">
        <a
          class="action-btn view-btn"
          [title]="'generalview' | translate"
          [href]="row.link"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
      </div>
    </ng-template>
  }
} @else {
  <p class="no-warnings">
    {{ 'resourcewarningsnotused' | translate }}
  </p>
}
